import styled from "styled-components"
import Section from "../components/Section"

const StyledHistory = styled.div`
  padding: var(--side-padding);
  display: flex;
  flex-direction: column;
  gap: 2rem;
`

// const Link = styled.a`
//   text-decoration: none;
//   color: var(--yellow);
//   font-weight: bold;
//   cursor: pointer;
// `

const History = () => {
  return (
    <StyledHistory>
      <Section
        title="At A Glance"
        body={
          <>
            <p>
              Under the leadership of Mrs. Nasrine Karim, the Earth Identity Project carried out 
              numerous programs to tackle the arsenic problem in the rural areas of Bangladesh by 
              spreading awareness about it and ensuring the supply of safe water supply through the 
              distribution of one thousand filters in the affected regions, that were developed by 
              Stevens Institute of Technology in New Jersey, USA.
            </p>
            <p>
              In June 2002, Earth Identity Project started 10 adult literacy programs in different 
              villages of Sylhet Sadar Upazila. In 2004, the NGO distributed relief items to the flood-hit 
              areas of Companiganj in Sylhet, Kachua in Cumilla, Devpur in Hajiganj, Subidpur, and various 
              rural villages in Chandpur.
            </p>
            <p>
              Noor-E-Farid Nasrine Academy a.k.a. The 40 is a unique initiative by the Earth Identity Project, 
              founded by Mrs. Nasrine Karim in 2009. It is a charitable enterprise that is essentially an orphanage 
              that selects 40 gifted orphans from a local region in Comilla and provides them with all their basic 
              necessities for life, including healthy, nutritious food as well as standardized full-time education - until 
              they become adults. The goal of this noble initiative is to fully prepare the selected orphans for a world 
              of opportunities and a real shot at happiness and prosperity in the future.
            </p>
          </>
        }
      />

      <Section
        title="Founder Profile"
        body={
          <>
            <p>
              Nasrine R. Karim, nee Choudhury, has lived in Rome, Paris, London, New York, Tokyo, Singapore, Jakarta, Lisbon, 
              and New Delhi as a child. Daughter of diplomat cum politician, late Humayun Rasheed Choudhury, Ms. Karim was 
              taught several European languages. Her final schooling was at Rodean, in Brighton, UK, and Convent of Jesus and 
              Mary's, Karachi, Pakistan. She graduated from Lucie Clayton School of Design, London in 1969. She holds an MBA 
              from St. Georges International University, Tokyo.
            </p>
            <p>
              Ms. Karim's first job was for ILO funded project in the Textile Ministry in Jakarta, Indonesia. During the Bangladesh 
              War of Independence, 1971, Ms. Karim worked at Thompson Bharat (Pvt) Ltd., a pioneer garment export company in New Delhi, 
              India. In 1985, Ms. Karim having honed her internationally developed skills, set up the first Design House in Bangladesh. Dia 
              House of Fashion Ltd created fusion designs, which were exported to the UK, Middle East, South Africa, and the USA.
            </p>
            <p>
              She was appointed as the Executive Director of the Earth Identity Project in 1999. She has worked with several vulnerable groups 
              such as people with arsenicosis, educationally challenged women and adults, and street children. She was also the Executive Director 
              of Humayun Rasheed Choudhury Foundation, named after her beloved father to promote Democracy, Civil Liberties, and Peace. She was an 
              Executive Member of the Commonwealth Association of Bangladesh.
            </p>
            <p>
              When she was about to launch Noor-E-Farid Academy, she became physically ill and went to London for treatment. While undergoing 
              treatment in London, doctors informed her that she had been affected by deadly cancer. She passed away on April 14, 2010, at the 
              Royal Marsden Hospital in London.
            </p>
          </>
        }
      />
    </StyledHistory>
  )
}

export default History